import React from 'react';
import CTA from "../../../components/Constant/cta/CTA";
import WhySection from "../../../components/WhySection/WhySection";
import IntroSection from "../../../components/IntroSection/IntroSection";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import Testimonials from "../../../components/Constant/Testimonials/Testimonials";
import DetailsSection from "../../../components/DetailsSection/DetailsSection";
import InfoBlocks from "../../../components/InfoBlocks/InfoBlocks";
import ServiceCards from "../../../components/ServiceCards/ServiceCards";
import {Helmet} from "react-helmet";


export default function AndorraResidencyGoldenVisa() {

    return (
        <main className='main'>

            <Helmet>
                <title>Andorra Residency & Golden Visa | Offshore Advisory</title>
                <meta name="description" content="Obtain Andorra residency and golden visa with Offshore Advisory. Expert guidance for investors and families to secure residency and tax benefits." />
                <meta name="keywords" content="
                    Andorra residency, Andorra golden visa, Andorra permanent residency, Andorra residency by investment, Andorra citizenship by residency, passive residency Andorra, Andorra residence permit, investor residency Andorra, Andorra tax benefits, Andorra family residency
                "
                />
            </Helmet>

            <IntroSection
                title="Andorra Residency and Golden Visa"
                description=
                    {
                        `Secure your future in Europe with Andorra residency and the exclusive Andorra golden visa program. Offshore Advisory offers comprehensive, professional guidance for individuals and families looking to establish a permanent presence in one of Europe’s most stable, secure, and tax-friendly countries.
                    <br/>
                    <br/>
                    Andorra has become a preferred destination for international investors, entrepreneurs, and high-net-worth individuals due to its combination of favorable tax policies, safe environment, and strategic location between France and Spain. With a residency permit or golden visa, you gain access to the Schengen Area, enjoy a high standard of living, and benefit from flexible investment opportunities, including property ownership and business establishment.
                    <br/>
                    <br/>
                    Our team at Offshore Advisory helps you navigate every step of the process, from choosing the right type of residency, preparing all necessary documents, to ensuring full compliance with Andorran law. Whether you are seeking passive residency through investment, planning to relocate your family, or aiming to take advantage of Andorra’s financial and lifestyle benefits, our tailored services make the journey seamless, efficient, and fully transparent.
                    <br/> <br/>
                    With Andorra residency, you’re not just relocating—you’re securing a gateway to Europe, financial efficiency, and long-term growth for you and your famil
                    `}
                imageSrc={require('../../../assets/images/Andorra-la-Vella-Modern-Urban-Skyline.jpg')}
                buttonText="Request a Andorra Golden Visa Consultation →"
                buttonLink="/quote"
                imageAlt="Andorra Golden Visa & Residency"
            />

            <section className='section'>
                <div className="container">
                    <WhySection
                        title='Why Choose Andorra Residency?'
                        subtitle="Andorra offers a unique combination of low taxes, political stability, and strategic location between Spain and France. By obtaining Andorra residency, you can:"
                        blocks={[
                            {
                                items: [
                                    { text: "Benefit from favorable tax regulations including passive residency options" },
                                    { text: "Access high-quality healthcare and education" },
                                    { text: "Enjoy a safe and secure living environment" },
                                    { text: "Travel freely across the Schengen Area with a residence permit" },
                                ]
                            }
                        ]}
                        end="Whether you are an entrepreneur, investor, or retiree, Andorra residency is ideal for those seeking a high-quality European lifestyle with significant financial advantages."
                    />

                    <InfoBlocks
                        title="Andorra Residency by Investment"
                        subtitle="Our golden visa and residency by investment program allows investors and high-net-worth individuals to secure permanent residency in Andorra efficiently. Key highlights include:"
                        blocks={[
                            {
                                items: [
                                    { title: "Passive Residency Option", text: "Residency through investment in Andorra without full-time employment" },
                                    { title: "Real Estate Investment", text: "Purchase property in Andorra to qualify for residency" },
                                    { title: "Business Investment", text: "Set up a company or invest in local enterprises" },
                                    { title: "Family Inclusion", text: "Extend residency rights to your spouse and dependents" },
                                ]
                            }
                        ]}
                        end="With Offshore Advisory, you receive personalized support, from selecting the right investment route to submitting applications and meeting all legal requirements."
                    />

                    <WhySection
                        title="Step-by-Step Andorra Residency Process"
                        subtitle="Offshore Advisory guides you through each stage of the process, ensuring a seamless and transparent experience."
                        blocks={[
                            {
                                items: [
                                    { title: "1. Consultation & Planning", text: "Consultation & Planning We begin by assessing your residency goals and eligibility. Our team discusses suitable investment options and tax planning strategies while providing a clear roadmap for obtaining Andorra residency." },
                                    { title: "2. Documentation & Application", text: "Next, we prepare all required legal documents and permits for your application. We handle the completion of residence permit and golden visa applications and coordinate with local authorities to ensure timely approval." },
                                    { title: "3. Investment & Compliance", text: "Once your application is underway, we provide guidance on property purchases or business investments. We ensure full compliance with Andorra’s fiscal and residency regulations and assist with opening bank accounts and meeting all legal obligations." },
                                    { title: "4. Permanent Residency & Ongoing Support", text: "After approval, we help you obtain your official residence permit or golden visa. Offshore Advisory also provides guidance on renewing permits or applying for citizenship by residency, along with ongoing advice for tax planning and compliance to ensure long-term benefits." },
                                ]
                            }
                        ]}
                        end="Whether you are an entrepreneur, investor, or retiree, Andorra residency is ideal for those seeking a high-quality European lifestyle with significant financial advantages."
                    />

                    <ServiceCards
                        title="Who Can Benefit?"
                        services={[
                            { title: "International Investors", text: "Secure a European residency with strong legal and financial protections" },
                            { title: "Entrepreneurs & Business Owners", text: "Set up companies and benefit from a low-tax environment" },
                            { title: "Families", text: "Include spouse and children for long-term residency benefits" },
                            { title: "High-Net-Worth Individuals", text: "Enjoy passive residency, lifestyle, and investment opportunities" },
                        ]}
                    />

                    <Testimonials
                        title="Our Client Testimonials"
                        paragraph='At Offshore Advisory, we take pride in helping clients achieve their dreams of Andorra residency and golden visa approval. Here’s what some of our clients have to say about their experience:'
                        testimonials={testimonialsData}
                    />

                    <FAQList data={faqData} title='FAQs About Andorra Residency & Golden Visa'/>

                    <DetailsSection
                        title='Why Choose Offshore Advisory?'
                        subtitle="With Offshore Advisory, you get:"
                        items={
                            [
                                { text: "Expertise in Andorra residency and golden visa programs" },
                                { text: "Personalized support throughout investment, application, and compliance" },
                                { text: "Transparent guidance with no hidden fees" },
                                { text: "Long-term support for renewals, citizenship, and tax planning" },
                            ]
                        }
                    />

                    <CTA
                        title="Contact Offshore Advisory Today!"
                        description="Ready to secure your Andorra residency or apply for the golden visa? Offshore Advisory makes the process simple, fast, and fully compliant."
                        buttonText="Get Started Today →"
                        buttonLink="/quote"
                    />
                </div>
            </section>
        </main>
    );
};

const faqData = [
    {
        question: "What is the Andorra golden visa?",
        answer: "The Andorra golden visa is a residency-by-investment program that allows foreign nationals to obtain Andorra residency by investing in property, business, or meeting passive residency requirements."
    },
    {
        question: "How long does it take to get Andorra residency?",
        answer: "The process typically takes 3 to 6 months, depending on the type of investment and completeness of your applicatio"
    },
    {
        question: "Can I include my family in my residency application?",
        answer: "Yes, spouses and dependents can be included under the Andorra residency program."
    },
    {
        question: "Do I need to live in Andorra full-time?",
        answer: "Passive residency allows you to maintain residency while spending part of the year in Andorra. Full-time residence is required for certain types of permits."
    },
    {
        question: "What are the tax benefits of Andorra residency?",
        answer: "Andorra offers low personal income tax rates, no inheritance tax, and favorable rules for passive income and investment."
    },
];

const testimonialsData = [
    {
        quote: "Offshore Advisory made the entire process of obtaining Andorra residency seamless and stress-free. Their team guided us through every step, from investment planning to final approval. Highly recommended!",
        author: "James L.",
        role: "Investor, UK"
    },
    {
        quote: "Thanks to Offshore Advisory, my family and I now enjoy the benefits of Andorra’s lifestyle and tax advantages. The team was professional, responsive, and extremely knowledgeable.",
        author: "Maria P.",
        role: "Entrepreneur, Spain"
    },
];


